var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',[_c('h3',{staticClass:"text-center mt-10"},[_vm._v("결제 실패")]),_c('v-btn',{staticClass:"primary rounded-10 d-flex mx-auto mt-6",attrs:{"depressed":""},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(" 홈으로 이동 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }